import { useLazyGetMyAccountParentQuery } from "@/src-refactor/modules/store/qrtk/services/myAccount/myAccount.qrtk";
import {
  CPropertyFormKeys,
  IPropertyForm
} from "../util/schemas/property-schema/propertySchema";
import { useFormContext } from "react-hook-form";
import { useCallback, useEffect } from "react";
import useUserHelp from "@/src-refactor/modules/shared/components/refactor/hooks/useUserHelp";
import { agentAutoCompleteItemAdapter } from "@rf/adapters/autocomplete-items/agentItemAdapters";
import { C_ASSOCIATES_TYPES } from "@/src-refactor/modules/shared/model/const/property/associates-types.conts";
import { debounce } from "lodash";

const useLoadCreatorUser = () => {
  const { getValues, setValue } = useFormContext<IPropertyForm>();
  const [triggerGetParent] = useLazyGetMyAccountParentQuery();
  const { USER_ROLE, USER } = useUserHelp();

  const loadCreatorUser = useCallback(() => {
    const isEdit = getValues(CPropertyFormKeys.is_edit);
    if (isEdit) return;

    const logged = USER.userData;
    if (!logged?.people_id) return;
    if (USER_ROLE.ADMIN || USER_ROLE.SUPER_ADMIN) return;

    const loggedAgent = agentAutoCompleteItemAdapter({
      id: logged.people_id,
      name: logged.name ?? "",
      picture: logged.picture ?? "",
      agencyName: logged.agency?.name,
      status: "active"
    });

    const setForm = (agents: any[]) => {
      setValue(CPropertyFormKeys.brokers_property as any, agents as any, {
        shouldDirty: true,
        shouldValidate: true
      });
      const associates =
        agents.length > 1
          ? [C_ASSOCIATES_TYPES.CO_BROKER]
          : [C_ASSOCIATES_TYPES.NINGUNO];
      setValue(
        CPropertyFormKeys.associates_type_property as any,
        associates as any,
        { shouldDirty: true, shouldValidate: true }
      );
    };

    if (USER_ROLE.JUNIOR) {
      triggerGetParent()
        .unwrap()
        .then(parent => {
          if (parent?.id) {
            const parentAgent = agentAutoCompleteItemAdapter({
              id: parent.id,
              name: parent.full_name ?? "",
              picture: parent.picture ?? "",
              status: "active",
              agencyName: logged.agency?.name
            });
            setForm([loggedAgent, parentAgent]);
          } else {
            setForm([loggedAgent]);
          }
        })
        .catch(() => {
          setForm([loggedAgent]);
        });
    } else {
      setForm([loggedAgent]);
    }
  }, [getValues, setValue, triggerGetParent, USER_ROLE.JUNIOR, USER.userData]);

  const dbLoadCreatorUser = debounce(() => {
    loadCreatorUser();
  }, 500);

  useEffect(() => {
    dbLoadCreatorUser();
    return () => {
      dbLoadCreatorUser.cancel();
    };
  }, []);
};
export default useLoadCreatorUser;
